<template>
  <section v-editable="blok" embed-player :data-spacing="blok?.spacing || 'open'" :style="[sectionStyles]">
    <div class="container">
      <div class="row section-row">
        <h2 v-if="blok?.title && title != ''" class="section-title" v-html="title"></h2>
        <div v-if="blok?.description && description != ''" class="section-description" v-html="description"></div>
        <div v-if="blok?.buttons?.length > 0" class="section-buttons">
          <StoryblokComponent v-for="button in blok?.buttons" :key="button._uid" :blok="button" />
        </div>
      </div>
      <div v-if="blok?.youtube_id" class="embed-wrapper">
        <LiteYouTubeEmbed :id="blok?.youtube_id" :title="`${stripTags(String(title))} Video`" poster="maxresdefault" :webp="true" :params="`start=0&playlist=${blok?.youtube_id}&loop=1&rel=0`" />
      </div>
      <div v-else class="embed-wrapper" v-html="blok?.html"></div>
      <div v-if="blok?.features?.length > 0" class="row">
        <div class="section-features" :data-odd="blok?.features.length % 2">
          <StoryblokComponent v-for="feature in blok?.features" :key="feature._uid" :blok="feature" />
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  import LiteYouTubeEmbed from "vue-lite-youtube-embed";
  import "vue-lite-youtube-embed/style.css";

  const props = defineProps({ blok: Object });

  const title = computed(() => useRichText(props?.blok?.title || {}));
  const description = computed(() => useRichText(props?.blok?.description || {}));

  const sectionStyles = computed(() => {
    return {
      "background-color": props.blok?.background_color?.value || "#F7F8FE",
    };
  });
</script>
<style src="~/assets/scss/section/embed-player.scss" lang="scss"></style>
